import $ from 'jquery';
import dom from '../../utils/dom';


const categoryAttributeName = 'data-tn-category';


/**
 * @param {HTMLElement} $el
 * @param {string} category
 */
function setCategoryAttribute($el, category) {
  $el.setAttribute(categoryAttributeName, category);
}


/**
 * @param {string} message
 * @param {boolean} focus
 * @param {string} category
 */
function addAlert(message, focus = false, category = null) {
  const $el = dom.makeElement('div', { name: 'tn-alert-message', class: 'tn-heading-info' });

  if (category) {
    setCategoryAttribute($el, category);
  }

  $el.innerHTML = message;

  const $target = dom.find('#tn-alert-message-template');

  dom.appendAfter($target, $el);

  $($el).show(100);

  if (focus) {
    focusUserOnMessages();
  }
}


/**
 * @param {string} message
 * @param {boolean} focus
 * @param {string} category
 */
function addError(errorMessage, focus = false, category = null) {
  const $el = dom.makeElement('div', { name: 'tn-error-message', class: 'bg-danger alert tn-heading-error' });

  if (category) {
    setCategoryAttribute($el, category);
  }

  $el.innerHTML = errorMessage;

  const $target = dom.find('#tn-error-message-template');

  dom.appendAfter($target, $el);

  $($el).show(100);

  if (focus) {
    focusUserOnMessages();
  }
}


/**
 * @param {HTMLElement[]} $els
 * @param {string} category
 */
function filterCategory($els, category) {
  return $els.filter($el => $el.getAttribute(categoryAttributeName) === category);
}


/**
 * @param {string} category
 */
function getAlertMessages(category = null) {
  const $els = dom.findAll('[name=\'tn-alert-message\']');

  if (category) {
    return filterCategory($els, category);
  }

  return $els;
}


/**
 * @param {string} category
 */
function getErrorMessages(category = null) {
  const $els = dom.findAll('[name=\'tn-error-message\']');

  if (category) {
    return filterCategory($els, category);
  }

  return $els;
}


function removeMessages(messages) {
  const $els = $(messages);

  $els.hide(100, () => {
    $els.remove();
  });
}


/**
 * @param {string} category
 */
function clearAlerts(category = null) {
  removeMessages(getAlertMessages(category));
}


/**
 * @param {string} category
 */
function clearErrors(category = null) {
  removeMessages(getErrorMessages(category));
}


/**
 * @param {string} category
 */
function clear(category = null) {
  clearAlerts(category);
  clearErrors(category);
}


function focusUserOnMessages() {
  const $el = $('#tn-error-message-template');
  const scrollTop = `${$el.offset().top - 10}px`;

  $('html, body').animate({ scrollTop }, 'fast');
}


/**
 * @param {string} category
 */
function testHasErrorMessages(category = null) {
  return getErrorMessages(category).length > 0;
}


export default {
  addAlert,
  addError,
  clearAlerts,
  clearErrors,
  focusUserOnMessages,
  testHasErrorMessages,
  clear,
};



// WEBPACK FOOTER //
// ./V7/tnew/ui/Messaging.js